import React, { Fragment, useEffect, useState } from "react";
import { Form, Container, Row, Col, Card, Breadcrumb, Button, Alert } from "@deere/ux.uxframe-react";
import { NEW_REQUEST4, ERROR_MESSAGE } from '../../shared/Constants';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { Loading } from '../../shared/Loading';
import moment from 'moment';
import '../../index.css'
import { useAuthConfig } from "../../shared/utils";
import { useUserInfo } from "../../shared/UserInfo";

export default function NewRequest4() {
    let authAxios = useAuthConfig();
    const info = useUserInfo();
    const history = useHistory();
    const location = useLocation();
    const [isLoading, setIsLoading] = useState(false);
    const [correctlocation, setCorrectlocation] = useState("");
    const [shipmethodims, setShipmethodims] = useState("");
    const [shipmethoduser, setShipmethoduser] = useState("");
    const [companyName, setCompanyName] = useState("");
    const [shipStreet1, setShipStreet1] = useState("");
    const [shipCity, setShipCity] = useState("");
    const [shipState, setshipState] = useState("");
    const [shipZip, setShipZip] = useState("");
    const [shipCountry, setShipCountry] = useState("");
    const [dock, setdock] = useState("");
    const [chargeaccount, setChargeaccount] = useState(location.state.chargeaccount);
    const [manchargeacct, setManchargeacct] = useState(location.state.manchargeacct);
    const [usereta, setUsereta] = useState("");
    const [useretaformatted, setUseretaformatted] = useState("");
    const [usereatformat, setUseretaformat] = useState("");
    const date = moment().format('YYYY-MM-DD');
    const date1 = moment().add(1, 'day').format('YYYY-MM-DD');
    const timestamp1 = moment().format('YYYY-MM-DD HH:MM:SS');
    const cutofftime = "03:45 PM";
    const [alertVisible, setAlertVisible] = useState(false);
    const [message, getMessage] = useState('');
    const [isDisabled, setIsDisabled] = useState(false);
    let submittype = "";
    const makeMessageHidden = () => {
        const timeout = setTimeout(() => {
            setAlertVisible(false)
        }, 5000)
        return () => clearTimeout(timeout)
    }
    const hideAlert = () => {
        setAlertVisible(false)
    }
    useEffect(() => {
        if (location.state.location === "ADC") {
            setCorrectlocation("Davenport, Iowa");
        } else if (location.state.location === "PDC") {
            setCorrectlocation("Milan, Illinois");
        } else {
            setCorrectlocation("UNKNOWN");
        }
        if (location.state.destination === 'other' && chargeaccount === '' && location.state.chargeto === 'D') {
            setChargeaccount("External")
        }
        if (manchargeacct !== '') {
            setChargeaccount(manchargeacct);
        } else {
            setManchargeacct("");
        }
    }, [])
    useEffect(() => {
        if (location.state.location === "PDC") {
            if (location.state.urgency === "Immediately") {
                setShipmethodims("WCALDY");
                setShipmethoduser("Will Call");
                if (location.state.plant === 'HX01' || location.state.plant === 'H101') {
                    setUsereta(moment().add(3, 'hours').format('hh:mm A'));
                    setUseretaformat(moment().format('MM/DD/YYYY'));
                    setUseretaformatted(date + "-" + moment().add(3, 'hours').format('hhmm'));
                } else if (location.state.plant === 'MX01' || location.state.plant === 'MX32') {
                    setUsereta(moment().add(6, 'hours').format('hh:mm A'));
                    setUseretaformat(moment().format('MM/DD/YYYY'))
                    setUseretaformatted(date + "-" + moment().add(6, 'hours').format('hhmm'));
                } else if (location.state.plant === 'LV01' || location.state.plant === 'GX01' || location.state.plant === 'GX03' || location.state.plant === 'TC01' || location.state.plant === 'TC04' || location.state.plant === 'TC37' || location.state.plant === 'T801') {
                    setUsereta("6:00 AM");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'));
                    setUseretaformatted(date1 + "-0600");
                } else {
                    setUsereta(moment().add(5, 'hours').format('hh:mm A'));
                    setUseretaformat(moment().format('MM/DD/YYYY'))
                    setUseretaformatted(date + "-" + moment().add(5, 'hours').format('hhmm'));
                }
            } else if (location.state.urgency === "Next Business Day (first thing)") {
                setShipmethodims("HTTKRR");
                setShipmethoduser("Overnight Std Forwarding");
                if (location.state.plant === "NX01") {
                    setUsereta("12:00 PM");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                    setUseretaformatted(date1 + "-1200");
                } else if (location.state.plant === 'DW01' || location.state.plant === 'H101' || location.state.plant === 'TX01') {
                    setUsereta("6:00 AM");
                    setUseretaformatted(date1 + "-0600");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                } else if (location.state.plant === "HX01") {
                    setUsereta("7:00 AM");
                    setUseretaformatted(date1 + "-0700");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                } else if (location.state.plant === "EX01" || location.state.plant === 'MX01' || location.state.plant === 'MX32') {
                    setUsereta("10:00 AM");
                    setUseretaformatted(date1 + "-1000");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                } else if (location.state.plant === "T801") {
                    setUsereta("9:30 AM");
                    setUseretaformatted(date1 + "-0930");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                } else if (location.state.plant === 'LV01' || location.state.plant === 'TC01' || location.state.plant === 'TC04' || location.state.plant === 'TC37') {
                    setUsereta("8:30 AM");
                    setUseretaformatted(date1 + "-0830");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                } else if (location.state.plant === "GX01" || location.state.plant === "GX03") {
                    setUsereta("11:00 AM");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                    setUseretaformatted(date1 + "-1100");
                }
                else {
                    setUsereta("9:00 AM");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                    setUseretaformatted(date1 + "-0900");
                }
            } else if (location.state.urgency === "2 Weeks") {
                setShipmethodims("STDFLT");
                setShipmethoduser("Standard Fleet");
                setUsereta(moment().add(21, 'days').format('dddd DD MMM YYYY'));
                setUseretaformatted(moment().add(21, 'days').format("YYYY-MM-DD") + "-0000");

            } else {
                setShipmethodims("UNKNWN");
                setShipmethoduser("Undeterminable");
                setUsereta("?");
                setUseretaformat(moment("9999-12-31").format('MM/DD/YYYY'))
                setUseretaformatted("9999-12-31-0000");
            }
        } else {
            if (location.state.urgency === "Immediately") {
                setShipmethodims("WCALDY");
                setShipmethoduser("Will Call");
                if (location.state.plant === 'HX01' || location.state.plant === 'H101') {
                    setUsereta(moment().add(3, 'hours').format('hh:mm A'));
                    setUseretaformat(moment().format('MM/DD/YYYY'))
                    setUseretaformatted(date + "-" + moment().add(3, 'hours').format('hhmm'));
                } else if (location.state.plant === 'MX01' || location.state.plant === 'MX32') {
                    setUsereta(moment().add(6, 'hours').format('hh:mm A'));
                    setUseretaformat(moment().format('MM/DD/YYYY'))
                    setUseretaformatted(date + "-" + moment().add(6, 'hours').format('hhmm'));
                } else if (location.state.plant === 'LV01' || location.state.plant === 'GX01' || location.state.plant === 'GX03' || location.state.plant === 'TC01' || location.state.plant === 'TC04' || location.state.plant === 'TC37' || location.state.plant === 'T801') {
                    setUsereta("6:00 AM");
                    setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                    setUseretaformatted(date1 + "-0600");
                } else {
                    setUsereta(moment().add(5, 'hours').format('hh:mm A'));
                    setUseretaformat(moment().format('MM/DD/YYYY'))
                    setUseretaformatted(date + "-" + moment().add(5, 'hours').format('hhmm'));
                }
            } else if (location.state.urgency === "Next Business Day (first thing)") {
                setShipmethodims("UPSNEM");
                setShipmethoduser("Overnight UPS NEM");
                setUsereta("8:30 AM");
                setUseretaformat(moment().add(1, 'day').format('MM/DD/YYYY'))
                setUseretaformatted(date1 + "-0830");
            } else if (location.state.urgency === "2 Weeks") {
                setShipmethodims("UPSNSU");
                setShipmethoduser("UPS NSU");
                setUsereta(moment().add(21, 'days').format('dddd DD MMM YYYY'));
                setUseretaformatted(moment().add(21, 'days').format("YYYY-MM-DD") + "-0000");
            } else {
                setShipmethodims("UNKNWN");
                setShipmethoduser("Undeterminable");
                setUsereta("?");
                setUseretaformat(moment("9999-12-31").format('MM/DD/YYYY'))
                setUseretaformatted("9999-12-31-0000");
            }
        }
    }, [])
    useEffect(() => {
        if (location.state.destination !== "other") {
            if (location.state.plant === "AX01" && location.state.destination === "Factory") {
                setCompanyName("John Deere Seeding Moline");
                setShipStreet1("501 River Drive ");
                setShipCity("Moline");
                setshipState("IA");
                setShipZip("61265");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "AX01" && location.state.destination === "EastMoline") {
                setCompanyName("Foundry SOUTH");
                setShipStreet1("1300 19th Street ");
                setShipCity("East Moline");
                setshipState("IL");
                setShipZip("61244");
                setShipCountry("US");
                setdock("85-92");
            }
            else if (location.state.plant === "AX02" && location.state.destination === "Factory") {
                setCompanyName("JD Seeding - Valley City");
                setShipStreet1("1725 7th St SE");
                setShipCity("Valley City");
                setshipState("ND");
                setShipZip("58072");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "AX02" && location.state.destination === "Magnum") {
                setCompanyName("Magnum Warehouse");
                setShipStreet1("4903 19th Ave N");
                setShipCity("Fargo");
                setshipState("ND");
                setShipZip("58102");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "AX02" && location.state.destination === "JDNorth") {
                setCompanyName("JD North");
                setShipStreet1("1024 4 Bottle Dr");
                setShipCity("Valley City");
                setshipState("ND");
                setShipZip("58072");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "EX01" && location.state.destination === "Factory") {
                setCompanyName("John Deere Ottumwa Works");
                setShipStreet1("928 E Vine St");
                setShipCity("Ottumwa");
                setshipState("IA");
                setShipZip("52501");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "JL01" && location.state.destination === "Factory") {
                setCompanyName("John Deere Paton");
                setShipStreet1("409 E Paton St");
                setShipCity("Paton");
                setshipState("IA");
                setShipZip("50217");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "MX01" || location.state.plant === "MX32") && location.state.destination === "Factory") {
                setCompanyName("John Deere Horicon Works");
                setShipStreet1("300 North Vine St");
                setShipCity("Horicon");
                setshipState("WI");
                setShipZip("53032");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "MX01" || location.state.plant === "MX32") && location.state.destination === "CCDC") {
                setCompanyName("CCDC / Landair Warehouse");
                setShipStreet1("2900 Beloit Ave");
                setShipCity("Janesville");
                setshipState("WI");
                setShipZip("53546");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "MX01" || location.state.plant === "MX32") && location.state.destination === "GatorWorks") {
                setCompanyName("Gator Works");
                setShipStreet1("1501 W LAKE ST");
                setShipCity("HORICON");
                setshipState("WI");
                setShipZip("53032");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "LV01" && location.state.destination === "Ryder") {
                setCompanyName("John Deere Commercial Prods");
                setShipStreet1("233 John Deere Parkway");
                setShipCity("Grovetown");
                setshipState("GA");
                setShipZip("30813");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "GX01" || location.state.plant === "GX03") && location.state.destination === "BuildingAC") {
                setCompanyName("John Deere Power Products");
                setShipStreet1("1630 Hal Henard Road");
                setShipCity("Greeneville");
                setshipState("TN");
                setShipZip("37743");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "GX01" || location.state.plant === "GX03") && location.state.destination === "BuildingD") {
                setCompanyName("John Deere Power Products");
                setShipStreet1("1750 Hal Henard Road");
                setShipCity("Greeneville");
                setshipState("TN");
                setShipZip("37743");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "GX01" || location.state.plant === "GX03") && location.state.destination === "BuildingG") {
                setCompanyName("John Deere Power Products");
                setShipStreet1("1510 Hal Henard Road");
                setShipCity("Greeneville");
                setshipState("TN");
                setShipZip("37743");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "GX01" || location.state.plant === "GX03") && location.state.destination === "BuildingH") {
                setCompanyName("John Deere Power Products");
                setShipStreet1("1500 Hal Henard Road");
                setShipCity("Greeneville");
                setshipState("TN");
                setShipZip("37743");
                setShipCountry("US");
                setdock("");
            }
            else if ((location.state.plant === "TC01" || location.state.plant === "TC04" || location.state.plant === "TC37") && location.state.destination === "Factory") {
                setCompanyName("John Deere Turf Care");
                setShipStreet1("6501 S. NC 55 Highway");
                setShipCity("Fuquay-Varina");
                setshipState("NC");
                setShipZip("27526");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "RX01" && location.state.destination === "DTO") {
                if (location.state.usingdept.substr(0, 1) === "6") {
                    getMessage(`${location.state.usingdept} is not a valid department for ${location.state.destination} delivery, please go back and adjust.`)
                    setAlertVisible(true);
                    makeMessageHidden();
                } else {
                    setCompanyName("John Deere Waterloo Works");
                    setShipStreet1("400 Westfield Ave");
                    setShipCity("Waterloo");
                    setshipState("IA");
                    setShipZip("50703");
                    setShipCountry("US");
                    setdock("574");
                }
            }
            else if (location.state.plant === "RX01" && location.state.destination === "Ryder") {
                setCompanyName("Ryder Logistics Center");
                setShipStreet1("2280 Northeast Drive");
                setShipCity("Waterloo");
                setshipState("IA");
                setShipZip("50703");
                setShipCountry("US");
                location.state.usingdept.substr(0, 1) === "6" ? setdock("LSC") : setdock("???")
            }
            else if (location.state.plant === "HX01" && location.state.destination === "Jacobson") {
                setCompanyName("John Deere Harvester Works");
                setShipStreet1("3145 5th Ave");
                setShipCity("East Moline");
                setshipState("IL");
                setShipZip("61244");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "HX01" && location.state.destination === "Factory") {
                setCompanyName("John Deere Harvester Works");
                setShipStreet1("1100 13th Ave");
                setShipCity("East Moline");
                setshipState("IL");
                setShipZip("61244");
                setShipCountry("US");
                setdock("K9");
            }
            else if (location.state.plant === "HX01" && location.state.destination === "Std Fwd") {
                setCompanyName("John Deere Harvester Works");
                setShipStreet1("2925 Morton Dr");
                setShipCity("East Moline");
                setshipState("IL");
                setShipZip("61244");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "H101" && location.state.destination === "Factory") {
                setCompanyName("John Deere Cylinder Division");
                setShipStreet1("909 River Drive");
                setShipCity("Moline");
                setshipState("IA");
                setShipZip("61265");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "H101" && location.state.destination === "Z11/RIAM Warehouse") {
                setCompanyName("John Deere Cylinder Division");
                setShipStreet1("7800 51st St W");
                setShipCity("Rock Island");
                setshipState("IL");
                setShipZip("61201");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "NX01" && location.state.destination === "Factory") {
                setCompanyName("John Deere Des Moines Work");
                setShipStreet1("602 SW State St");
                setShipCity("Ankeny");
                setshipState("IA");
                setShipZip("50023");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "NX01" && location.state.destination === "LSC") {
                setCompanyName("John Deere Ankeny LSC");
                setShipStreet1("5800 SE Delaware Ave");
                setShipCity("Ankeny");
                setshipState("IA");
                setShipZip("50021");
                setShipCountry("US");
                setdock("2S");
            }
            else if (location.state.plant === "T801" && location.state.destination === "plant3") {
                setCompanyName("JDT - Plant 3");
                setShipStreet1("256 Highway 3266");
                setShipCity("Thibodaux");
                setshipState("LA");
                setShipZip("70301");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "DW01" && location.state.destination === "Factory") {
                setCompanyName("John Deere Davenport Works");
                setShipStreet1("1175 E 90th St");
                setShipCity("Davenport");
                setshipState("IA");
                setShipZip("52806");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "DW01" && location.state.destination === "TM") {
                setCompanyName("TM Logistics");
                setShipStreet1("288 E 90th St");
                setShipCity("Davenport");
                setshipState("IA");
                setShipZip("52806");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "TX01" && location.state.destination === "Factory") {
                setCompanyName("John Deere Cross Dock");
                setShipStreet1("18600 S John Deere Rd");
                setShipCity("Dubuque");
                setshipState("IA");
                setShipZip("52001");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "TX01" && location.state.destination === "W6") {
                setCompanyName("John Deere Dubuque - W6");
                setShipStreet1("18029 Riverside Rd");
                setShipCity("Dubuque");
                setshipState("IA");
                setShipZip("52001");
                setShipCountry("US");
                setdock("");
            }
            else if (location.state.plant === "YK01" && location.state.destination === "PU") {
                setCompanyName("Precision Upgrades");
                setShipStreet1("272 E 90th St");
                setShipCity("Davenport");
                setshipState("IA");
                setShipZip("52806");
                setShipCountry("US");
                setdock("");
            }
        } else {
            setCompanyName(location.state.companyName);
            setShipStreet1(location.state.shipStreet);
            setShipCountry(location.state.shipCountry);
            setShipCity(location.state.shipCity);
            setshipState(location.state.shipState);
            setShipZip(location.state.shipZip);
            setdock(location.state.dock);
        }
    }, []);
    const handleStep3 = () => {
        history.push({
            pathname: '/step3', state: {
                plant: location.state.plant, material: location.state.material, quantity: location.state.quantity,
                availQtyNegative: location.state.availQtyNegative, available_date: location.state.available_date, reason: location.state.reason,
                urgency: location.state.urgency, destination: location.state.destination, replenshment_source: location.state.replenshment_source,
                deliverattention: location.state.deliverattention, pcsOfInventory: location.state.pcsOfInventory, factoryDailyUsage: location.state.factoryDailyUsage, 
                nextShipmentDate: location.state.nextShipmentDate, whyNeededFrmPDC: location.state.whyNeededFrmPDC, typicalReplenishment: location.state.typicalReplenishment,
                comments: location.state.comments, recquantity: location.state.recquantity, partdescription: location.state.partdescription,
                quantityontheshelf: location.state.quantityontheshelf, materialWeight: location.state.materialweight,
                inventoryclass: location.state.inventoryclass, location: location.state.location,
                mrpController: location.state.mrpController,
                partPlanner: location.state.partPlanner,
                sourceSuppName: location.state.sourceSuppName,
                supplier: location.state.supplier,
                additionalCCEmails: location.state.additionalCCEmails
            }
        })
    }
    const handleSubmit = (e) => {
        e.preventDefault();
        submittype = "submit"
        const data = {
            requestorId: info.userId, destinationAttn: location.state.deliverattention, pcsOfInventory: location.state.pcsOfInventory, factoryDailyUsage: location.state.factoryDailyUsage, nextShipmentDate: location.state.nextShipmentDate, whyNeededFrmPDC: location.state.whyNeededFrmPDC, userEta: usereta,
            urgency: location.state.urgency, location: location.state.location, plant: location.state.plant,
            dept: location.state.usingdept, comments: location.state.comments, material: location.state.material,
            quantityDesired: location.state.quantity, destination: location.state.destination, mrpController: location.state.mrpController,
            partPlanner: location.state.partPlanner, quantityOnTheShelf: location.state.quantityontheshelf, partDesc: location.state.partdescription,
            materialWeight: location.state.materialweight, production: location.state.production, reason: location.state.reason,
            sourceSuppName: location.state.sourceSuppName, supplier: location.state.supplier, chargeAccount: chargeaccount,
            chargeReason: location.state.chargereason, chargeTo: location.state.chargeto, shipCity: shipCity,
            shipCountry: shipCountry, shipState: shipState, companyName: companyName,
            shipStreet1: shipStreet1, zip: shipZip, supplierFault: location.state.supplier_fault,
            dock: dock, shipMethodIMS: shipmethodims, shipMethodUser: shipmethoduser,
            userEtaFormatted: useretaformatted, timestamp1: timestamp1, recommendedQty: location.state.recquantity,
            gr: location.state.gr, typicalReplenishmentSource: location.state.typicalReplenishment, replenishmentSource: location.state.replenshment_source,
            part20: location.state.available_date, submitType: submittype, attPhone: location.state.attnphone,
            additionalCCEmails: location.state.additionalCCEmails
        }
        setIsDisabled(true);
        setIsLoading(true);
                authAxios.post(`/PDCReturn/RequestSubmit`, data).then(res => {
            setIsLoading(false);
             if (res.data.isDataInserted === true) {
                history.push({
                    pathname: "/step5", state: {
                        material: location.state.material,
                        submittype: submittype,
                        comments: location.state.comments
                    }
                })
            } else {
                getMessage(ERROR_MESSAGE);
                setAlertVisible(true);
                setIsDisabled(false);
                setIsLoading(false);
                makeMessageHidden();
            }
        }).catch(() => {
            getMessage(ERROR_MESSAGE);
            setAlertVisible(true);
            setIsLoading(false);
            setIsDisabled(false);
            makeMessageHidden();
        })
    }
    const handleSubmitanother = (e) => {
        e.preventDefault();
        submittype = "submit another";
        const data = {
            requestorId: info.userId, destinationAttn: location.state.deliverattention, pcsOfInventory: location.state.pcsOfInventory, factoryDailyUsage: location.state.factoryDailyUsage, nextShipmentDate: location.state.nextShipmentDate, whyNeededFrmPDC: location.state.whyNeededFrmPDC, userEta: usereta,
            urgency: location.state.urgency, location: location.state.location, plant: location.state.plant,
            dept: location.state.usingdept, comments: location.state.comments, material: location.state.material,
            quantityDesired: location.state.quantity, destination: location.state.destination, mrpController: location.state.mrpController,
            partPlanner: location.state.partPlanner, quantityOnTheShelf: location.state.quantityontheshelf, partDesc: location.state.partdescription,
            materialWeight: location.state.materialweight, production: location.state.production, reason: location.state.reason,
            sourceSuppName: location.state.sourceSuppName, supplier: location.state.supplier, chargeAccount: chargeaccount,
            chargeReason: location.state.chargereason, chargeTo: location.state.chargeto, shipCity: shipCity,
            shipCountry: shipCountry, shipState: shipState, companyName: companyName,
            shipStreet1: shipStreet1, zip: shipZip, supplierFault: location.state.supplier_fault,
            dock: dock, shipMethodIMS: shipmethodims, shipMethodUser: shipmethoduser,
            userEtaFormatted: useretaformatted, timestamp1: timestamp1, recommendedQty: location.state.recquantity,
            gr: location.state.gr, typicalReplenishmentSource: location.state.typicalReplenishment, replenishmentSource: location.state.replenshment_source,
            part20: location.state.available_date, submitType: submittype, attPhone: location.state.attnphone,
            additionalCCEmails: location.state.additionalCCEmails
        }
        setIsDisabled(true);
        setIsLoading(true);
        authAxios.post(`/PDCReturn/RequestSubmit`, data).then(res => {
            setIsLoading(false);
            if (res.data.isDataInserted === true) {
                history.push("/step1");
            } else {
                getMessage(ERROR_MESSAGE);
                setAlertVisible(true)
                setIsLoading(false);
                setIsDisabled(false);
                makeMessageHidden()
            }
        }).catch(err => {
            getMessage(ERROR_MESSAGE);
            setIsDisabled(false);
            makeMessageHidden()
            setIsLoading(false);
        })
    }
    return (
        <Fragment>
            <title>Confirm Your PDC Parts Request (step 4)</title>
            {alertVisible ? <Alert id="snackbar" onClose={hideAlert} accessibilityLabel="Success:" variant="warning" aria-atomic="true">
                <p className="uxf-alert-description">
                    {message}
                </p>
            </Alert> : null}
            <Card style={{ margin: '2%' }}>
                <Card.Body>
                    <Container fluid="xl">
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Breadcrumb links={[
                                        {
                                            title: "Home",
                                            to: "/"
                                        }, {
                                            title: "Step1",
                                            to: "/step1"
                                        },
                                        {
                                            title: "Step2",
                                            to: {
                                                pathname: "/step2", state: {
                                                    plant: location.state.plant,
                                                    material: location.state.material,
                                                    quantity: location.state.quantity
                                                }
                                            }
                                        },
                                        {
                                            title: "Step3",
                                            to: {
                                                pathname: "/step3", state: {
                                                    plant: location.state.plant, material: location.state.material, quantity: location.state.quantity,
                                                    availQtyNegative: location.state.availQtyNegative, available_date: location.state.available_date, reason: location.state.reason,
                                                    urgency: location.state.urgency, destination: location.state.destination, replenshment_source: location.state.replenshment_source,
                                                    deliverattention: location.state.deliverattention, typicalReplenishment: location.state.typicalReplenishment,
                                                    comments: location.state.comments, recquantity: location.state.recquantity, partdescription: location.state.partdescription,
                                                    quantityontheshelf: location.state.quantityontheshelf, materialWeight: location.state.materialweight,
                                                    inventoryclass: location.state.inventoryclass, location: location.state.location,
                                                    additionalCCEmails: location.state.additionalCCEmails
                                                }
                                            }

                                        }, {
                                            title: "Step4"
                                        }
                                    ]} breadcrumbItemProps={{ linkAs: Link }} />
                                </Form.Group>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={24}>
                                <Form.Group as={Row} className="mb-3" >
                                    <Form.Label className='firstline' style={{ marginLeft: '2%' }}>
                                        {NEW_REQUEST4}
                                    </Form.Label>
                                </Form.Group>
                            </Col>
                        </Row>
                    </Container>
                    <Form>
                        <Container>
                            <Form.Group style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Form.Label className="uxf-label">
                                    Please review your request before submitting:
                                </Form.Label>
                            </Form.Group>
                            <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Card.Body >
                                    <Card.Title>Basic Information</Card.Title>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Plant: </Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Part: </Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Part description: </Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Reason: </Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Quantity: </Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Urgency:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={8}>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.plant}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.material}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.partdescription}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.reason}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.quantity}</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.urgency}&nbsp;</Form.Label>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <br />
                            <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Card.Body >
                                    <Card.Title>Delivery Information</Card.Title>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Company Name:  </Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Attention: </Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Address: </Form.Label>
                                            </Form.Group>
                                            {location.state.destination !== "other" ? <>
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>Dept:  </Form.Label>
                                                </Form.Group>
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>Dock: </Form.Label>
                                                </Form.Group></>
                                                : null}
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>City:</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>State:</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Country:</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Zip:</Form.Label>
                                            </Form.Group>
                                            {location.state.destination === "other" ?
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>Phone:</Form.Label>
                                                </Form.Group>
                                                : null}
                                        </Col>
                                        <Col xs={12} md={8}>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{companyName}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.deliverattention}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{shipStreet1}&nbsp;</Form.Label>
                                            </Form.Group>
                                            {location.state.destination !== "other" ? <>
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label> {location.state.usingdept}&nbsp; </Form.Label>
                                                </Form.Group>
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>{dock}&nbsp;</Form.Label>
                                                </Form.Group></>
                                                : null}
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{shipCity}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{shipState}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{shipCountry}&nbsp;</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{shipZip}&nbsp;</Form.Label>
                                            </Form.Group>
                                            {location.state.destination === "other" ?
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label> {location.state.attnphone}&nbsp;</Form.Label>
                                                </Form.Group>
                                                : null}
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <br />
                            {location.state.destination === "other" ? <>
                                <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                    <Card.Body >
                                        <Card.Title>Charge Information</Card.Title>
                                        <Row>
                                            <Col xs={12} md={8}>
                                                {location.state.chargeto === "D" ? <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>Charge Account:  </Form.Label>
                                                </Form.Group> : null}
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>Charge Reason:</Form.Label>
                                                </Form.Group>
                                            </Col>
                                            <Col xs={12} md={8}>
                                                {location.state.chargeto === "D" ? <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>{chargeaccount}&nbsp;</Form.Label>
                                                </Form.Group> : null}
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>{location.state.chargereason}&nbsp;</Form.Label>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                                <br /></>
                                : null}
                            <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Card.Body >
                                    <Card.Title>Additional Information</Card.Title>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            {location.state.comments !== "" ? <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Final comments from the requestor:</Form.Label>
                                            </Form.Group> : null}
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Part location:</Form.Label>
                                            </Form.Group>
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>Earliest ETA:</Form.Label>
                                            </Form.Group>
                                        </Col>
                                        <Col xs={12} md={7}>
                                            {location.state.comments !== "" ? <Form.Group style={{ marginLeft: 10 }}>
                                                <Form.Label>{location.state.comments}&nbsp;</Form.Label>
                                            </Form.Group> : null}
                                            <Form.Group style={{ marginLeft: '1%' }}>
                                                <Form.Label>{location.state.location} - {correctlocation}&nbsp;</Form.Label>
                                            </Form.Group>
                                            {useretaformatted !== '' && (location.state.urgency === "Immediately" || location.state.urgency === "Next Business Day (first thing)") ?
                                                <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>{usereatformat} - {usereta}&nbsp;</Form.Label>
                                                </Form.Group>
                                                : <Form.Group style={{ marginLeft: '1%' }}>
                                                    <Form.Label>{usereta}&nbsp;</Form.Label>
                                                </Form.Group>
                                            }
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>
                            <br />
                            <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Card.Body >
                                    <ul type="circle">
                                        <li>
                                            If the data you provided is not correct, use your browser's <Button style={{ padding: 0, paddingBottom: 3 }} variant="link" onClick={handleStep3}>Back</Button> button to make corrections...
                                        </li>
                                        {dock === 'undeterminable' ?
                                            <li>
                                                WARNING: YOU DID NOT CHOOSE A VALID DELIVER TO DEPARTMENT.<br />
                                                Please go back and choose a valid department.
                                            </li>
                                            : <>
                                                <li> Requests submitted after {cutofftime} probably will not be processed until the following morning.</li>
                                                <li> To submit your request for hot parts, click the send button below. You will be copied as FYI on the request.</li>
                                            </>}
                                    </ul>
                                </Card.Body>
                            </Card>
                            <br />
                            {(moment('09:00 AM', 'hh:mm a').isBefore(moment()) && location.state.urgency === "Immediately") ?
                                <>
                                    <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                        <Card.Body style={{ marginLeft: '1%' }}>
                                            <Form.Label className="uxf-label">CAUTION: TO SAVE MONEY YOU MAY PREFER TO WAIT UNTIL TOMORROW!</Form.Label><br />
                                            <Form.Label>Since it will take until around {usereta} to get this order to you and same
                                                day expedites are significantly more expensive than next day, you may want
                                                to consider downgrading the urgency of this request to "Next Business Day".<br />
                                                If you want to do this, please use the <Button style={{ padding: 0, paddingBottom: 3 }} variant="link" onClick={handleStep3}>Back</Button> button, otherwise click send.</Form.Label>
                                        </Card.Body>
                                    </Card><br />
                                </>
                                : null}
                            {moment(cutofftime, 'hh:mm a').isBefore(moment()) ?
                                <>
                                    <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                        <Card.Body style={{ marginLeft: '1%' }}>
                                            <Form.Label className="uxf-label">CAUTION: CURRENT TIME IS LATER THAN {cutofftime}!</Form.Label><br />
                                            <Form.Label>This request probably will not be processed until tomorrow morning.</Form.Label>
                                        </Card.Body>
                                    </Card><br />
                                </>
                                : null}
                            <Card style={{ marginLeft: '5%', marginRight: '5%' }}>
                                <Card.Body>
                                    <Form.Label className="uxf-label">*Please use the Submit Button to submit a single request or the final request in a bundle of requests.</Form.Label><br />
                                    <Form.Label className="uxf-label">Please use the Submit Another button to submit this request and return to Step 1 to enter another request</Form.Label>
                                    <Form.Label className="uxf-label">this will indicate to the processors that additional requests are going to be entered.</Form.Label><br />
                                </Card.Body>
                            </Card>
                            <br />
                            {isLoading ? (
                                <Loading />
                            ) : null}
                            <Row>
                                <Col>
                                    <Form.Group as={Row} style={{ marginLeft: '7%', marginRight: '5%' }}>
                                        <Button variant="primary" type="submit" disabled={isDisabled} onClick={handleSubmit}>
                                            <font style={{ "fontWeight": "bold" }}>Submit</font>
                                        </Button>&nbsp;&nbsp;
                                        <Button variant="secondary" type="submit" disabled={isDisabled} onClick={handleSubmitanother}>
                                            <font style={{ "fontWeight": "bold" }}>Submit Another</font>
                                        </Button>
                                    </Form.Group>
                                </Col>
                            </Row>
                        </Container>
                    </Form>
                </Card.Body>
            </Card>
        </Fragment>
    )
}
